import { AppFlex } from 'shared/UI/UIKit/Flex';
import { AppButton } from 'shared/UI/UIKit/Button';

type TeacherWorkloadModalFooterProps = {
  hideModal: () => void;
  onSubmit: () => void;
  title: string;
};

export const TeacherWorkloadModalFooter = ({
  hideModal,
  onSubmit,
  title,
}: TeacherWorkloadModalFooterProps) => {
  return (
    <AppFlex direction="row">
      <AppButton onClick={onSubmit}>{title}</AppButton>
      <AppButton type="outline" onClick={hideModal}>
        Отмена
      </AppButton>
    </AppFlex>
  );
};
